// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__PSGKT","pulse":"styles_pulse__nLHew","jump":"styles_jump__fsSBW"};